module.exports = __webpack_public_path__ + "static/media/sewing_kit.614b6c48.svg";